import { datadogRum } from "@datadog/browser-rum";
import { ErrorInfo } from "react";

export function addReactError(name: string, error: Error, info: ErrorInfo) {
  const datadogRumError = new Error(error.message);
  datadogRumError.name = name;
  datadogRumError.stack = info.componentStack ?? undefined;
  datadogRumError.cause = error;
  datadogRum.addError(datadogRumError);
}
